import { Modal } from './Modal';
import { ModalClose } from './Close';
Modal.Close = ModalClose;
export { Modal };